// extracted by mini-css-extract-plugin
export default {"main":"main_main__8k8Ga","main__logo":"main_main__logo__bXp0H","main__span":"main_main__span__jlR+x","main__start":"main_main__start__pLcAs"};